import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Panel, Col, Row } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import * as FicheActions from 'redux/modules/fiches';
/*
import { isLoaded as areFichesLoaded, load as loadFiches } from 'redux/modules/fiches';
import { isLoaded as areGroupsLoaded, load as loadGroups } from 'redux/modules/groups';
*/
import { analyseState } from 'utils/analyseState';

import './dashboard.css'


import { SyncProductsTableAdmin } from 'components';

import _ from 'underscore';

var elevator = require('../../../static/img/elevator.png')
var escalator = require('../../../static/img/escalator.png')

import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({
    products: state.products.data,
    user: state.auth.user,
    dashboardOptions: state.fiches.dashboardOptions

  }),
  dispatch => bindActionCreators({ ...FicheActions }, dispatch)
)
export default class ResumePanelAdmin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      openPannes: false,
      openDisactivated: false,
      openSync: false,
      openTravaux: false,
      openProducts: false,
      openUsagers: false,
      CK: true,
      CN: true

    };

    this.openPanel = this.openPanel.bind(this);
  }

  componentWillUnmount() {

  }


  openPanel(panel) {


    var obj = {
      openProducts: false,
      openDisactivated: false,
      openTravaux: false,
      openPannes: false,
      openUsagers: false,
      openCyclical: false
    }

    obj[panel] = !this.state[panel]


    _.each(obj, (v, k) => {
      if (panel == k) {
        this.props.setDashboardOptions(k, !this.props.dashboardOptions[k].open)
      } else {
        this.props.setDashboardOptions(k, false)
      }
    })

    //this.props.setDashboardOptions(panel)

    //this.setState(obj)

  }



  render() {

    const {t} = this.props

    var products = this.props.products || [];

    var {
      openProducts, openUsagers,
      openPannes, openDisactivated,
      openTravaux, openCyclical } = this.props.dashboardOptions;

    var syncTable = [];
    var pannesTable = [];
    var unfinishedTable = [];
    var disactivatedTable = [];
    var travauxTable = [];

    var productTable = [];

    var cyclicalTable = [];

    var requiredFields = [/*'identification_GSM', */'identification_NUM_ASC', 'identification_ID', 'localisation_adresse']

    var usager_products = []

    //products = products.filter((p)=>p.identification_fosse < 1 || p.identification_fosse == null)

    _.each(products, function (p) {


      if ((p.identification_fosse < 1 || p.identification_fosse == null)) {

        var s_etat = analyseState(p.s_etat)

        if (_.where(p.timeline_rows, { type: 'usager', end_code: null }).length > 0) {
          usager_products.push(p)
        }


        productTable.push(p)

        var row =
          <div>
            <LinkContainer to={'/client/product/' + p.id + '/edit'}>
              <button className="btn btn-primary">
                {'Produit ' + p.id}  <i className="fa fa-pencil" />
              </button>
            </LinkContainer><br />
          </div>


        for (var j = 0; j < requiredFields.length; j++) {
          var field = requiredFields[j];
          if (p[field] == '') {
            var style = 'warning';
            unfinishedTable.push(p);
            break;
          }
        }


        if (p.etat_indisponibilite_sts == 1) {
          disactivatedTable.push(p)
        } else {

          if (p.last_cyclical_row && p.last_cyclical_row.call_type != 'CO') {
            cyclicalTable.push(p)
          }
        }

        if (p.etat_en_panne == 1) {
          pannesTable.push(p)
        }

        if (p.etat_en_travaux == 1) {
          travauxTable.push(p)
        }

      } else {

        if (p.last_cyclical_row && p.etat_indisponibilite_sts == 0 && p.last_cyclical_row.call_type != 'CO') {
          cyclicalTable.push(p)
        }

      }

    })


    if (this.state.CK == false) {
      cyclicalTable = cyclicalTable.filter((e) => e.last_cyclical_row.call_type == 'CN')

    }

    if (this.state.CN == false) {
      cyclicalTable = cyclicalTable.filter((e) => e.last_cyclical_row.call_type == 'CK')
    }





    /*
    var header1 =
      <div onClick={() => syncTable.length > 0 && this.openPanel('openSync')} style={{ cursor: 'pointer', position: "absolute", 'bottom': '-15px', 'right': 10, 'fontSize': '13px' }} className="panel-heading" >
        <div className="row">
          <div className="col-xs-3">
            <i className="fa fa-exchange fa-4x"></i>
          </div>
          <div className="col-xs-9 text-right" style={{ height: '100px' }}>
            <h3 >Fiches STS ({syncTable.length})</h3>

            {syncTable.length > 0 &&
              <div >
                {!this.state.openSync ? 't("main.open")' : 't("main.close")'}
              </div>
            }
          </div>
        </div>
      </div>*/




    var header2 =
      <div onClick={() => pannesTable.length > 0 && this.openPanel('openPannes')} className="panel-heading" >
        <div className="row">
          <div className="col-xs-3">
            <i className="fa fa-warning fa-4x"></i>
          </div>
          <div className="col-xs-9 text-right" style={{ height: '100px' }}>
            <h3 >{t('resume_panel.pannes_install')} {genHeader(pannesTable, t)}</h3>

            {pannesTable.length > 0 &&
              <div style={{ cursor: 'pointer', position: "absolute", 'bottom': '-15px', 'right': 10, 'fontSize': '13px' }}>
                {!openPannes.open ? t("main.open") : t("main.close")}
              </div>
            }

          </div>
        </div>
      </div>


    var header4 =
      <div onClick={() => disactivatedTable.length > 0 && this.openPanel('openDisactivated')} className="panel-heading">
        <div className="row">
          <div className="col-xs-3">
            <i className="fa fa-minus-circle fa-4x"></i>
          </div>
          <div className="col-xs-9 text-right" style={{ height: '100px' }}>
            <h3 >{t('resume_panel.indispo_sts')} {genHeader(disactivatedTable, t)}</h3>


            {disactivatedTable.length > 0 &&
              <div style={{ cursor: 'pointer', position: "absolute", 'bottom': '-15px', 'right': 10, 'fontSize': '13px' }}>
                {!openDisactivated.open ? t("main.open") : t("main.close")}
              </div>
            }

          </div>
        </div>
      </div>



    var header5 =
      <div onClick={() => productTable.length > 0 && this.openPanel('openProducts')} className="panel-heading">
        <div className="row" style={{ height: "100px" }}>
          <div style={{ float: 'left' }}>
            <img width="60" src={elevator} title="Ascenseur" /> &nbsp;<img width="60" title="Escalier mécanique" src={escalator} />
          </div>
          <div style={{ float: 'right' }} >
            <h3 > {productTable.length} {t('resume_panel.sts_sheets')}</h3>

            {productTable.length > 0 &&
              <div style={{ cursor: 'pointer', position: "absolute", 'right': "32px", 'fontSize': '13px' }} >
                {!openProducts.open ? t("main.open") : t("main.close")}
              </div>
            }
          </div>
        </div>
      </div>


    var header7 =
      <div onClick={() => travauxTable.length > 0 && this.openPanel('openTravaux')} className="panel-heading">
        <div className="row">
          <div className="col-xs-3">
            <i className="fa fa-wrench fa-4x"></i>
          </div>
          <div className="col-xs-9 text-right">
            <h3 >{t('resume_panel.travaux_install')} {genHeader(travauxTable, t)}</h3>

            {travauxTable.length > 0 &&
              <div style={{ cursor: 'pointer', position: "absolute", 'bottom': '-15px', 'right': 10, 'fontSize': '13px' }}>
                {!openTravaux.open ? t("main.open") : t("main.close")}
              </div>
            }

          </div>
        </div>
      </div>




    var header8 = (

      <div onClick={() => usager_products.length > 0 && this.openPanel('openUsagers')} className="panel-heading" >
        <div className="row">
          <div className="col-xs-3">
            <i className="fa fa-warning fa-4x"></i>
          </div>
          <div className="col-xs-9 text-right" style={{ height: '100px' }}>
            <h3 >{t('resume_panel.blocked_users')} {genHeader(usager_products, t)}</h3>

            {usager_products.length > 0 &&
              <div style={{ cursor: 'pointer', position: "absolute", 'bottom': '-15px', 'right': 10, 'fontSize': '13px' }}>
                {!openUsagers.open ? t("main.open") : t("main.close")}
              </div>
            }

          </div>
        </div>
      </div>)


    var header9 = (

      <div onClick={() => cyclicalTable.length > 0 && this.openPanel('openCyclical')} className="panel-heading" >
        <div className="row">
          <div className="col-xs-3">
            <i className="fa fa-refresh fa-4x"></i>
          </div>
          <div className="col-xs-9 text-right" style={{ height: '100px' }}>
            <h3>{t('resume_panel.cyclical_default')} {/*Téléalarmes*/} {genHeader(cyclicalTable, t)}</h3>

            {cyclicalTable.length > 0 &&
              <div style={{ cursor: 'pointer', position: "absolute", 'bottom': '-15px', 'right': 10, 'fontSize': '13px' }}>
                {!openCyclical.open ? t("main.open") : t("main.close")}
              </div>
            }

          </div>
        </div>
      </div>
    )

    var colSize;
    var CO_COUNT = _.where(cyclicalTable, { 'last_call_type': 'CO' }).length;
    var CK_COUNT = _.where(cyclicalTable, { 'last_call_type': 'CK' }).length;
    var CN_COUNT = _.where(cyclicalTable, { 'last_call_type': 'CN' }).length;

    return (
      <div>
        <Row>
          <Col className={openProducts.open ? 'col-xs-12 col-md-12 ' : 'col-xs-12 col-md-4 '} >
            <Panel bsStyle="primary" header={header5} collapsible expanded={openProducts.open} style={{ overflow: 'hidden', 'minHeight': '142px' }}>
              <SyncProductsTableAdmin
                params={this.props.params} edit={true}
                products={productTable} style="primary" type="normal"
                panel="openProducts" />
            </Panel>
          </Col>

          <Col className={openPannes.open ? 'col-xs-12 col-md-12 ' : 'col-xs-12 col-md-4 '} >
            <Panel bsStyle="danger" header={header2} collapsible expanded={openPannes.open} style={{ overflow: 'hidden', 'minHeight': '142px' }}>
              {pannesTable.length > 0 &&
                <SyncProductsTableAdmin params={this.props.params} edit={true} products={pannesTable} style="primary" type='pannes' panel="openPannes" />
              }
            </Panel>
          </Col>


          <Col className={openUsagers.open ? 'col-xs-12 col-md-12 ' : 'col-xs-12 col-md-4 '} >
            <Panel bsStyle="danger" header={header8} collapsible expanded={openUsagers.open} style={{ overflow: 'hidden', 'minHeight': '142px' }}>
              <SyncProductsTableAdmin params={this.props.params} edit={true} products={usager_products} style="primary" type='usager' panel="openUsagers" />
            </Panel>
          </Col>

        </Row>

        <Row>
          <Col className={openDisactivated.open ? 'col-xs-12 col-md-12 ' : 'col-xs-12 col-md-4 '} >
            <Panel bsStyle="warning" header={header4} collapsible expanded={openDisactivated.open} style={{ overflow: 'hidden', 'minHeight': '142px' }}>
              {disactivatedTable.length > 0 &&
                <SyncProductsTableAdmin params={this.props.params} edit={true} products={disactivatedTable} style="primary" type='indisponible' panel="openDisactivated" />
              }
            </Panel>
          </Col>

          <Col className={openTravaux.open ? 'col-xs-12 col-md-12 ' : 'col-xs-12 col-md-4 '} >
            <Panel bsStyle="warning" header={header7} collapsible expanded={openTravaux.open} style={{ overflow: 'hidden', 'minHeight': '142px' }}>
              {travauxTable.length > 0 &&
                <SyncProductsTableAdmin params={this.props.params} edit={true} products={travauxTable} style="primary" type='travaux' panel="openTravaux" />
              }
            </Panel>
          </Col>


          <Col className={openCyclical.open ? 'col-xs-12 col-md-12 ' : 'col-xs-12 col-md-4 '} >
            <Panel bsStyle="warning" header={header9} collapsible expanded={openCyclical.open}
              style={{ overflow: 'hidden', 'minHeight': '142px' }}>
              <div > {/*
                  <Row style={{margin:'5px'}}>
                    <Col className={ 'col-xs-12 col-md-5'} style={{border:"1px solid grey", padding:'7px'}} >
                      <b>Récapitulatif : </b> 
                      <p>                                      
                        Test cyclique non aquitté par la centrale (<b>CN</b>) : {CN_COUNT} produits<br/>                    
                        Test cyclique non reçu au bout de 4 jours (<b>CK</b>) : {CK_COUNT} produits     
                      </p>
                      
                    </Col>
                  </Row>*/}


                CK : <input id="onlyCK" type="checkbox" checked={this.state.CK} onChange={(el) => { this.setState({ CK: el.target.checked }) }} /><br />
                CN : <input id="onlyCN" type="checkbox" checked={this.state.CN} onChange={(el) => { this.setState({ CN: el.target.checked }) }} />

                <div>
                  {cyclicalTable.length > 0 &&
                    <SyncProductsTableAdmin
                      params={this.props.params}
                      edit={true} products={cyclicalTable}
                      style="primary" type='cyclical'
                      panel="openCyclical"
                    />
                  }
                </div>

              </div>



            </Panel>
          </Col>





        </Row>

      </div>
    );
  }
}


function createRow(p, style) {

  return (<tr>
    <td>{p.identification_ID}</td>
    <td>{p.groups}</td>
    <td>{p.localisation_adresse}</td>
    <td>
      <LinkContainer to={'/client/product/' + p.id + '/edit'}>
        <button className={"btn btn-" + style}>
          <i className="fa fa-pencil" />
        </button>
      </LinkContainer>
    </td>
  </tr>)
}


function genHeader(array, t) {
  if (array.length > 0) {

    return <div style={{ fontSize: '17px' }}>({array.length} {t("main.sheets")})</div>

  } else {
    return <div style={{ fontSize: '17px' }}>({t("main.no_sheets")})</div>
  }

}

function createTable(rows) {

  return (

    <table className="table table-striped">
      <tr>
        <th>ID</th>
        <th>Groupe(s)</th>
        <th>Adresse</th>
        <th>Action</th>
      </tr>

      {rows}

    </table>


  )

}